<ng-container *transloco="let t">
<ng-template #typeOfLoan>
  @if (inEditMode) {
    <div class="d-flex mb-4">
      <label class="fs-6 col-sm-4 col-form-label fw-bold fs-6 editor-label">Show Child Care Questions for VA Loan:</label>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid" style="margin-top: 8px;">
        <input class="form-check-input h-20px w-30px" type="checkbox" id="showChildCareQuestionsForVaLoan"
          [ngModelOptions]="{standalone: true}" [(ngModel)]="step.showChildCareQuestionsForVALoans" />
        <label class="form-check-label" for="showChildCareQuestionsForVaLoan">
          {{step.showChildCareQuestionsForVALoans ? "Yes" : "No"}}
        </label>
      </div>
    </div>
  }
  <form #loanInfoForm="ngForm" novalidate id="loanInfoForm" name="loanInfoForm">
    @if (!isHidden('mortgageApplication.mortgageTerm.mortgageAppliedFor')) {
      <div class="col-lg-8 fv-row mb-3"
        [ngClass]="{'mb-10': !isMobile}">
        <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
          [ngClass]="{'required': isRequired('mortgageApplication.mortgageTerm.mortgageAppliedFor')}">
          <span class="">{{getLabel('mortgageApplication.mortgageTerm.mortgageAppliedFor', t('wizard.loan.chooseLoanType'))}}</span>
        </label>
        <select name="loanType"
          [(ngModel)]="loanTypeId"
          (ngModelChange)="onLoanTypeChanged()"
          #loanType="ngModel"
          [required]="isRequired('mortgageApplication.mortgageTerm.mortgageAppliedFor')"
          [ngClass]="{'is-invalid' : loanType && loanType.touched && loanType.invalid}"
          class="form-select form-select-solid" #loanType1="ngModel" [attr.data-placeholder]="t('wizard.loan.selectLoanType')" [disabled]="inCoApplyFlow">
          <option [ngValue]="null">{{ t('wizard.loan.selectOneOption') }}</option>
          <option value="-1">{{ t('wizard.loan.iDontKnow') }}</option>
          @for (loanType of loanTypes; track loanType.loanTypeId) {
            <option value="{{loanType.loanTypeId}}">
              {{loanType.loanTypeName}}
            </option>
          }
        </select>
        <div class="invalid-feedback">{{ t('wizard.loan.pleaseSelectLoanType') }}</div>
      </div>
    }
    @if (mortgageAppliedForType === 'VA' && step.showChildCareQuestionsForVALoans) {
      <div class="row mb-10 rounded"
      [ngClass]="{
        'mt-10': !isMobile,
        'is-invalid' : hasChildCareExpensesQuestion && hasChildCareExpensesQuestion.touched && hasChildCareExpensesQuestion.invalid,
        'border' : hasChildCareExpensesQuestion && hasChildCareExpensesQuestion.touched && hasChildCareExpensesQuestion.invalid,
        'border-danger' : hasChildCareExpensesQuestion && hasChildCareExpensesQuestion.touched && hasChildCareExpensesQuestion.invalid
      }">
      <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
        <span class="">{{ t('wizard.loan.doYouHaveChildCareExpenses') }}</span>
      </label>
      <div class="col-md-2" [ngClass]="{'mt-2': isMobile}">
        <div class="d-flex">
          <div class="form-check form-check-custom form-check-solid">
            <input
              class="form-check-input"
              name="hasChildCareExpensesQuestionInput"
              required
              [value]="true"
              type="radio"
              id="aYes"
              [(ngModel)]="hasChildCareExpenses" #hasChildCareExpensesQuestion="ngModel"/>
            <label style="padding-right: 6px;" class="form-check-label" for="aYes">{{ t('common.yes') }}</label>
          </div>
          <div class="form-check form-check-custom form-check-solid ms-8">
            <input
              class="form-check-input"
              name="hasChildCareExpensesQuestionInput"
              required
              [value]="false"
              type="radio"
              id="aNo"
              [(ngModel)]="hasChildCareExpenses" #hasChildCareExpensesQuestion="ngModel"/>
            <label style="padding-right: 6px;" class="form-check-label" for="aNo">{{ t('common.no') }}</label>
          </div>
        </div>
      </div>
    </div>
    }
    @if (hasChildCareExpenses) {
      <div class="card shadow-sm mb-10">
        <div class="card-header">
            <h3 class="card-title">{{ t('wizard.loan.childCareExpenses') }}</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                [ngClass]="'required'">
                <span class="">{{ t('wizard.loan.childCareProviderName') }}</span>
              </label>
              <input type="text" class="form-control form-control-solid"
                [required]="true"
                [ngClass]="{'is-invalid' : providerName && providerName.touched && providerName.invalid}"
                [(ngModel)]="mortgage.governmentLoanDetail.childCareProviderName" placeholder="" name="providerName"
                #providerName="ngModel" [readonly]="inCoApplyFlow"/>
                <div class="invalid-feedback">{{ t('wizard.loan.providerNameRequired') }}</div>
            </div>
            <div class="col-md-6">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                [ngClass]="'required'">
                <span class="">{{ t('wizard.loan.childCareCostPerMonth') }}</span>
              </label>
              <input type="text" class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [required]="true"
                [ngClass]="{'is-invalid' : costPerMonth && costPerMonth.touched && costPerMonth.invalid}"
                [(ngModel)]="mortgage.governmentLoanDetail.childCareCostPerMonth" placeholder="" name="costPerMonth"
                #costPerMonth="ngModel" [readonly]="inCoApplyFlow" />
              <div class="invalid-feedback">{{ t('wizard.loan.costPerMonthRequired') }}</div>
            </div>
            <div class="col-md-12 mt-4">
              <address #childCareProviderAddressComponent [showCountry]="true" [address]="childCareProviderAddress" [required]="true"></address>
            </div>
          </div>
        </div>
      </div>
    }
    @if (loanTypeId != null && !isRefinance) {
      <div>
        <div class="d-flex row" [ngClass]="{'mb-7': !isMobile}">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span class="">{{ t('wizard.loan.crunchingNumbers') }}</span>
          </label>
        </div>
        <div class="d-flex row" [ngClass]="{'mb-7': !isMobile || !downpayment}">
          @if (!isHidden('mortgage.transactionDetail.purchasePriceAmount')) {
            <div class="col-md-6">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                [ngClass]="{'required': isRequired('mortgage.transactionDetail.purchasePriceAmount')}">
                <span class="">{{getLabel('mortgage.transactionDetail.purchasePriceAmount', t('wizard.loan.purchasePrice'))}}</span>
              </label>
              <input type="text" class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [required]="isRequired('mortgage.transactionDetail.purchasePriceAmount')"
                [ngClass]="{'is-invalid' : purchasePrice && purchasePrice.touched && purchasePrice.invalid}"
                [(ngModel)]="mortgage.transactionDetail.purchasePriceAmount" placeholder="" name="purchasePrice"
                (blur)="onPurchasePriceChanged()"
                #purchasePrice="ngModel" [readonly]="inCoApplyFlow"/>
                <div class="invalid-feedback">{{ t('wizard.loan.purchasePriceRequired') }}</div>
            </div>
          }
          @if (!isHidden('mortgage.transactionDetail.downpayment')) {
            <div class="col-md-6">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                [ngClass]="{'required': isRequired('mortgage.transactionDetail.downpayment') && loanTypeId !== '3'}">
                <span class="">{{getLabel('mortgage.transactionDetail.downpayment', t('wizard.loan.downPayment'))}}</span>
              </label>
              <input type="text" class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [required]="isRequired('mortgage.transactionDetail.downpayment') && loanTypeId !== '3'"
                [ngClass]="{'is-invalid' : downPayment && downPayment.touched && downPayment.invalid}"
                [(ngModel)]="downpayment" placeholder="" name="downPayment"
                (blur)="onDownPaymentChanged()"
                #downPayment="ngModel" [readonly]="inCoApplyFlow" />
              <div class="invalid-feedback">{{ t('wizard.loan.downPaymentRequired') }}</div>
            </div>
          }
          @if (!isHidden('mortgage.mortgageTerm.appraisedValue')) {
            <div class="col-md-6">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                [ngClass]="{'required': isRequired('mortgage.mortgageTerm.appraisedValue')}">
                <span class="">{{ getLabel('mortgage.mortgageTerm.appraisedValue', 'Appraised Value') }}</span>
              </label>
              <input type="text" class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [required]="isRequired('mortgage.mortgageTerm.appraisedValue')"
                [ngClass]="{'is-invalid' : appraisedValuePurchase && appraisedValuePurchase.touched && appraisedValuePurchase.invalid}"
                [(ngModel)]="mortgage.mortgageTerm.appraisedValue" placeholder="" name="appraisedValuePurchase"
                (blur)="onAppraisedValueChanged()"
                #appraisedValuePurchase="ngModel" [readonly]="inCoApplyFlow" />
              <div class="invalid-feedback">{{ t('wizard.loan.appraisedValueRequired') }}</div>
            </div>
          }
        </div>
        @if (downpayment) {
          <div class="d-flex mb-3 row" [ngClass]="{'mb-7': !isMobile}">
            @if (!isHidden('mortgage.subjectProperty.downPaymentSource')) {
              <div class="col-md-6">
                <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                  [ngClass]="{'required': isRequired('mortgage.subjectProperty.downPaymentSource')}">
                  <span class="">{{getLabel('mortgage.subjectProperty.downPaymentSource', t('wizard.loan.downPaymentSource'))}}</span>
                </label>
                <select name="downPaymentSource" [(ngModel)]="mortgage.subjectProperty.downPaymentSource"
                  class="form-select form-select-solid" #downPaymentSource="ngModel"
                  [required]="isRequired('mortgage.subjectProperty.downPaymentSource')"
                  [ngClass]="{'is-invalid' : downPaymentSource && downPaymentSource.touched && downPaymentSource.invalid}"
                  [attr.data-placeholder]="t('wizard.loan.selectDownPaymentSource')" [disabled]="inCoApplyFlow">
                  <option [ngValue]="null">{{ t('common.selectOne') }}</option>
                  @for (downPaymentSourceType of downPaymentSourceTypes; track downPaymentSourceType.value) {
                    <option value="{{downPaymentSourceType.value}}">
                      {{downPaymentSourceType.name}}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">{{ t('wizard.loan.downPaymentSourceRequired') }}</div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (loanTypeId != null && isRefinance) {
      <div>
        <div class="d-flex row" [ngClass]="{'mb-7': !isMobile}">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span class="">{{ t('wizard.loan.crunchingNumbers') }}</span>
          </label>
        </div>
        <div class="d-flex mb-7 row">
          @if (!isHidden('mortgage.subjectProperty.presentValue')) {
            <div class="col-md-6">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                [ngClass]="{'required': isRequired('mortgage.subjectProperty.presentValue')}">
                <span class="">{{ getLabel('mortgage.subjectProperty.presentValue', t('wizard.loan.estimatedValue')) }}</span>
              </label>
              <input type="text" class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [(ngModel)]="mortgage.subjectProperty.presentValue" placeholder="" name="presentValue" (change)="onEstimatedValueChanged()"
                [required]="isRequired('mortgage.subjectProperty.presentValue')"
                [ngClass]="{'is-invalid' : presentValue1 && presentValue1.touched && presentValue1.invalid}"
                #presentValue1="ngModel" />
              <div class="invalid-feedback">{{ t('wizard.loan.estimatedValueRequired') }}</div>
            </div>
          }
          @if (!isHidden('mortgage.mortgageTerm.appraisedValue')) {
            <div class="col-md-6">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
                [ngClass]="{'required': isRequired('mortgage.mortgageTerm.appraisedValue')}">
                <span class="">{{ getLabel('mortgage.mortgageTerm.appraisedValue', 'Appraised Value') }}</span>
              </label>
              <input type="text" class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [(ngModel)]="mortgage.mortgageTerm.appraisedValue" placeholder="" name="appraisedValue" (change)="onAppraisedValueChanged()"
                [required]="isRequired('mortgage.mortgageTerm.appraisedValue')"
                [ngClass]="{'is-invalid' : appraisedValue1 && appraisedValue1.touched && appraisedValue1.invalid}"
                #appraisedValue1="ngModel" [readonly]="inCoApplyFlow" />
              <div class="invalid-feedback">{{ t('wizard.loan.appraisedValueRequired') }}</div>
            </div>
          }
          <div class="col-md-6">
            <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
              <span class="">{{ t('wizard.loan.loanAmount') }}</span>
            </label>
            <div class="position-relative">
              <input type="text" class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                [(ngModel)]="estimatedLoanAmount" placeholder="" name="amount" #amount1="ngModel" (change)="onLoanAmountChanged()"
                required [readonly]="inCoApplyFlow"
                [ngClass]="{'is-invalid' : amount1 && amount1.touched && amount1.invalid}"/>
              <div class="invalid-feedback">{{ t('wizard.loan.loanAmountRequired') }}</div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (loanTypeId != null && !isRefinance && downpayment) {
      <div>
        <div class="d-flex row" [ngClass]="{'mb-7': !isMobile}">
          <div class="col-md-6">
            <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
              <span class="">{{ t('wizard.loan.estimatedLoanAmount') }}: {{estimatedLoanAmount | currency}} </span>
            </label>
          </div>
        </div>
        <div class="d-flex mb-7 row">
          <div class="col-md-6">
            <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
              <span class="">{{ t('wizard.loan.estimatedLTV') }}: {{estimatedLTV? estimatedLTV : ""}}% ({{ t('wizard.loan.basedOnHomeValue') }}: {{homeValue| currency}}) </span>
            </label>
          </div>
        </div>
      </div>
    }
  </form>
</ng-template>

<wizard-step-template [stepMainTemplate]="typeOfLoan" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
